import NumberFormat from 'react-number-format';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function PayoutFormatter({ info }) {
  const { value } = getInfo(info)
  if (!value) return null
  return <NumberFormat value={value} displayType="text" thousandSeparator={true} prefix="$ " />
}
